'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Paragraph } from '../paragraph/paragraph.js';

/**
 * FieldsetDescription component, used to display a description for a fieldset.
 *
 * @example
 * <FieldsetDescription>
 *   Gi en kort beskrivelse i begge feltene
 * </FieldsetDescription>
 */
const FieldsetDescription = forwardRef(function FieldsetDescription(rest, ref) {
    return jsx(Paragraph, { ref: ref, ...rest });
});

export { FieldsetDescription };
